/**
 * variables
 */
let debug = false

let dataCheckBox = document.getElementById('data-safety')
let fakeSubmitButton = document.getElementById('fake-submit-button')
let submitButton = document.getElementById('submit-button')

let formFirstNameCounter = 0
let formLastNameCounter = 0
let formEmailCounter = 0
let formPhoneCounter = 0
let formSubjectCounter = 0
let formMessageCounter = 0
let formAppointmentCounter = 0
let formOriginCounter = 0
let formWebsiteCounter = 0
let formCompanyCounter = 0
let formObjectiveCounter = 0
let formSalutationCounter = 0
let formActivityCounter = 0
let formStreetCounter = 0
let formPostalCodeCounter = 0
let formCityCounter = 0
let formCarCounter = 0

let formFirstName = document.getElementById('form-first-name')
let formLastName = document.getElementById('form-last-name')
let formEmail = document.getElementById('form-email')
let formPhone = document.getElementById('form-phone')
let formSubject = document.getElementById('form-subject')
let formMessage = document.getElementById('form-message')
let formAppointment = document.getElementById('form-appointment')
let formOrigin = document.getElementById('form-origin')
let formWebsite = document.getElementById('form-website')
let formCompany = document.getElementById('form-company')
let formObjective = document.getElementById('form-objective')
let formSalutation = document.getElementById('form-salutation')
let formActivity = document.getElementById('form-activity')
let formStreet = document.getElementById('form-street')
let formPostalCode = document.getElementById('form-postal-code')
let formCity = document.getElementById('form-city')
let formCar = document.getElementById('form-car')


let thisForm = document.getElementById('Form_RequestForm')
let thisFormAppointment = document.getElementById('Form_AppointmentForm')
//let formActionFeedback = document.getElementById('action-message')

/**
 * insert after function
 */
function insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);

}
function removeInsertAfter(referenceNode) {
    referenceNode.parentNode.removeChild(referenceNode.nextSibling)
}
/**
 * insert before function
 */
function insertBefore(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
}

/**
 * validate email
 */
function validateEmail(email)
{
    let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,20})+$/
    return !email.match(emailFormat);
}

/**
 * validate email
 */
function validateWebsite(email)
{
    let emailFormat = /^((ftp|http|https):\/\/)?www\.([A-z]+)\.([A-z]{2,})/
    return !email.match(emailFormat);
}

/**
 * validate phone number
 */
function validatePhoneNumber(number)
{
    let phoneFormat = /^\+?([0-9]{2})\)?([0-9]{8,12})$/;
    return !(number.match(phoneFormat));
}

/**
 * validate name
 */
if (formFirstName) {
    formFirstName.addEventListener('change', () => {
        if(formFirstName.hasAttribute('required')){
            console.log('firstname required!')
        }
        if (formFirstNameCounter === 0) {
            formFirstNameCounter += 1
        } else {
            removeInsertAfter(formFirstName)
        }
        let newEl = document.createElement('div')
        if (formFirstName.value.length < 1) {
            newEl.classList.add('invalid-feedback')
            formFirstName.classList.remove('is-valid')
            formFirstName.classList.add('is-invalid')
            newEl.innerHTML = 'Dieses Feld darf nicht leer sein.'
            insertAfter(newEl, formFirstName)
        } else {
            newEl.classList.add('valid-feedback')
            formFirstName.classList.remove('is-invalid')
            formFirstName.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formFirstName)
        }
    })
}

/**
 * validate name
 */
if (formLastName) {
    formLastName.addEventListener('change', () => {
        if(formLastName.hasAttribute('required')){
            console.log('lastname required!')
        }
        if (formLastNameCounter === 0) {
            formLastNameCounter += 1
        } else {
            removeInsertAfter(formLastName)
        }
        let newEl = document.createElement('div')
        if (formLastName.value.length < 1) {
            newEl.classList.add('invalid-feedback')
            formLastName.classList.remove('is-valid')
            formLastName.classList.add('is-invalid')
            newEl.innerHTML = 'Dieses Feld darf nicht leer sein.'
            insertAfter(newEl, formLastName)
        } else {
            newEl.classList.add('valid-feedback')
            formLastName.classList.remove('is-invalid')
            formLastName.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formLastName)
        }
    })
}

/**
 * validate company
 */
if (formCompany) {
    formCompany.addEventListener('change', () => {
        if (formCompanyCounter === 0) {
            formCompanyCounter += 1
        } else {
            removeInsertAfter(formCompany)
        }

        let newEl = document.createElement('div')

        if(formCompany.hasAttribute('required')){
            console.log('company required!')
            if (formCompany.value.length < 1) {
                newEl.classList.add('invalid-feedback')
                formCompany.classList.remove('is-valid')
                formCompany.classList.add('is-invalid')
                newEl.innerHTML = 'Firmenname scheint etwas kurz zu sein.'
                insertAfter(newEl, formCompany)
            } else {
                newEl.classList.add('valid-feedback')
                formCompany.classList.remove('is-invalid')
                formCompany.classList.add('is-valid')
                newEl.innerHTML = 'Sieht sehr gut aus!'
                insertAfter(newEl, formCompany)
            }
        } else {
            if (formCompany.value.length < 1) {
                newEl.classList.add('invalid-feedback','is-optional')
                formCompany.classList.remove('is-valid')
                formCompany.classList.add('is-optional')
                newEl.innerHTML = 'Optional: Firmenname scheint etwas kurz zu sein.'
                insertAfter(newEl, formCompany)
            } else {
                newEl.classList.add('valid-feedback')
                formCompany.classList.remove('is-optional')
                formCompany.classList.add('is-valid')
                newEl.innerHTML = 'Sieht sehr gut aus!'
                insertAfter(newEl, formCompany)
            }
        }
    })
}


/**
 * validate street
 */
if (formStreet) {
    formStreet.addEventListener('change', () => {
        if (formStreetCounter === 0) {
            formStreetCounter += 1
        } else {
            removeInsertAfter(formStreet)
        }

        let newEl = document.createElement('div')

        if(formStreet.hasAttribute('required')){
            console.log('street required!')
            if (formStreet.value.length < 1) {
                newEl.classList.add('invalid-feedback')
                formStreet.classList.remove('is-valid')
                formStreet.classList.add('is-invalid')
                newEl.innerHTML = 'Dieses Feld darf nicht leer sein'
                insertAfter(newEl, formStreet)
            } else {
                newEl.classList.add('valid-feedback')
                formStreet.classList.remove('is-invalid')
                formStreet.classList.add('is-valid')
                //newEl.innerHTML = 'Sieht sehr gut aus!'
                //insertAfter(newEl, formStreet)
            }
        }
    })
}

/**
 * validate postalcode
 */
if (formPostalCode) {
    formPostalCode.addEventListener('change', () => {
        if (formPostalCodeCounter === 0) {
            formPostalCodeCounter += 1
        } else {
            removeInsertAfter(formPostalCode)
        }

        let newEl = document.createElement('div')

        if(formPostalCode.hasAttribute('required')){
            console.log('postalcode required!')
            if (formPostalCode.value.length < 4) {
                newEl.classList.add('invalid-feedback')
                formPostalCode.classList.remove('is-valid')
                formPostalCode.classList.add('is-invalid')
                newEl.innerHTML = 'Verwenden Sie ein valide Postleitzahl (4 Stellen)'
                insertAfter(newEl, formPostalCode)
            } else {
                newEl.classList.add('valid-feedback')
                formPostalCode.classList.remove('is-invalid')
                formPostalCode.classList.add('is-valid')
                //newEl.innerHTML = 'Sieht sehr gut aus!'
                //insertAfter(newEl, formStreet)
            }
        }
    })
}

/**
 * validate city
 */
if (formCity) {
    formCity.addEventListener('change', () => {
        if (formCityCounter === 0) {
            formCityCounter += 1
        } else {
            removeInsertAfter(formCity)
        }

        let newEl = document.createElement('div')

        if(formCity.hasAttribute('required')){
            console.log('city required!')
            if (formCity.value.length < 1) {
                newEl.classList.add('invalid-feedback')
                formCity.classList.remove('is-valid')
                formCity.classList.add('is-invalid')
                newEl.innerHTML = 'Dieses Feld darf nicht leer sein'
                insertAfter(newEl, formCity)
            } else {
                newEl.classList.add('valid-feedback')
                formCity.classList.remove('is-invalid')
                formCity.classList.add('is-valid')
                //newEl.innerHTML = 'Sieht sehr gut aus!'
                //insertAfter(newEl, formStreet)
            }
        }
    })
}

/**
 * validate email
 */
if (formEmail) {
    formEmail.addEventListener('change', () => {
        if(formEmail.hasAttribute('required')){
            console.log('email required!')
        }
        if (formEmailCounter === 0) {
            formEmailCounter += 1
        } else {
            removeInsertAfter(formEmail)
        }
        let newEl = document.createElement('div')
        if (validateEmail(formEmail.value)) {
            newEl.classList.add('invalid-feedback')
            formEmail.classList.remove('is-valid')
            formEmail.classList.add('is-invalid')
            newEl.innerHTML = 'Deine E-Mail-Adresse scheint nicht gültig zu sein.'
            insertAfter(newEl, formEmail)
        } else {
            newEl.classList.add('valid-feedback')
            formEmail.classList.remove('is-invalid')
            formEmail.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formEmail)
        }
    })
}

/**
 * validate website
 */
if (formWebsite) {
    formWebsite.addEventListener('change', () => {
        if (formWebsiteCounter === 0) {
            formWebsiteCounter += 1
        } else {
            removeInsertAfter(formWebsite)
        }
        let newEl = document.createElement('div')
        if(formWebsite.hasAttribute('required')){
            console.log('website required!')
            if (validateWebsite(formWebsite.value)) {
                newEl.classList.add('invalid-feedback')
                formWebsite.classList.remove('is-valid')
                formWebsite.classList.add('is-invalid')
                newEl.innerHTML = 'Deine Web-Adresse scheint nicht korrekt zu sein. Beispiel(https://www.awesome.com)'
                insertAfter(newEl, formWebsite)
            } else {
                newEl.classList.add('valid-feedback')
                formWebsite.classList.remove('is-invalid')
                formWebsite.classList.add('is-valid')
                newEl.innerHTML = 'Web Crawler Ready!'
                insertAfter(newEl, formWebsite)
            }
        } else {
            if (validateWebsite(formWebsite.value)) {
                newEl.classList.add('invalid-feedback','is-optional')
                formWebsite.classList.remove('is-valid')
                formWebsite.classList.add('is-optional')
                newEl.innerHTML = 'Optional: Deine Web-Adresse scheint nicht korrekt zu sein. Beispiel(https://www.awesome.com)'
                insertAfter(newEl, formWebsite)
            } else {
                newEl.classList.add('valid-feedback')
                formWebsite.classList.remove('is-optional')
                formWebsite.classList.add('is-valid')
                newEl.innerHTML = 'Web Crawler Ready!'
                insertAfter(newEl, formWebsite)
            }
        }
    })
}

/**
 * validate phone number
 */
if (formPhone) {
    formPhone.addEventListener('change', () => {
        if (formPhoneCounter === 0) {
            formPhoneCounter += 1
        } else {
            removeInsertAfter(formPhone)
        }
        let newEl = document.createElement('div')
        if(formPhone.hasAttribute('required')){
            console.log('phone required!')
            if (validatePhoneNumber(formPhone.value)) {
                newEl.classList.add('invalid-feedback')
                formPhone.classList.remove('is-valid')
                formPhone.classList.add('is-invalid')
                newEl.innerHTML = 'Deine Telefonnummer scheint nicht gültig zu sein. (Beispiel +436641234567)'
                insertAfter(newEl, formPhone)
            } else {
                newEl.classList.add('valid-feedback')
                formPhone.classList.remove('is-invalid')
                formPhone.classList.add('is-valid')
                //newEl.innerHTML = 'Sieht sehr gut aus!'
                //insertAfter(newEl, formPhone)
            }
        } else {
            if (validatePhoneNumber(formPhone.value)) {
                newEl.classList.add('invalid-feedback','is-optional')
                formPhone.classList.remove('is-valid')
                formPhone.classList.add('is-optional')
                newEl.innerHTML = 'Optional: Deine Telefonnummer scheint nicht gültig zu sein. (Beispiel +436641234567)'
                insertAfter(newEl, formPhone)
            } else {
                newEl.classList.add('valid-feedback')
                formPhone.classList.remove('is-optional')
                formPhone.classList.add('is-valid')
                //newEl.innerHTML = 'Sieht sehr gut aus!'
                //insertAfter(newEl, formPhone)
            }
        }
    })
}

/**
 * validate subject
 */
if (formSubject) {
    formSubject.addEventListener('change', () => {
        if(formSubject.hasAttribute('required')){
            console.log('subject required!')
        }
        if (formSubjectCounter === 0) {
            formSubjectCounter += 1
        } else {
            removeInsertAfter(formSubject)
        }
        let newEl = document.createElement('div')
        if (formSubject.value.length < 1) {
            newEl.classList.add('invalid-feedback')
            formSubject.classList.remove('is-valid')
            formSubject.classList.add('is-invalid')
            newEl.innerHTML = 'Dieses Feld darf nicht leer sein.'
            insertAfter(newEl, formSubject)
        } else {
            newEl.classList.add('valid-feedback')
            formSubject.classList.remove('is-invalid')
            formSubject.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formSubject)
        }
    })
}

/**
 * validate message
 */
if (formMessage) {
    formMessage.addEventListener('change', () => {
        if (formMessageCounter === 0) {
            formMessageCounter += 1
        } else {
            removeInsertAfter(formMessage)
        }
        if(formMessage.hasAttribute('required')){
            console.log('message required!')
            let newEl = document.createElement('div')
            if (formMessage.value.length < 25) {
                newEl.classList.add('invalid-feedback')
                formMessage.classList.remove('is-valid')
                formMessage.classList.add('is-invalid')
                newEl.innerHTML = 'Deine Nachricht scheint etwas kurz zu sein.'
                insertAfter(newEl, formMessage)
            } else {
                newEl.classList.add('valid-feedback')
                formMessage.classList.remove('is-invalid')
                formMessage.classList.add('is-valid')
                //newEl.innerHTML = 'Sieht sehr gut aus!'
                //insertAfter(newEl, formMessage)
            }
        }
    })
}

/**
 * validate date appointment
 */
if (formAppointment) {
    formAppointment.addEventListener('change', () => {
        if(formAppointment.hasAttribute('required')){
            console.log('appointment required!')
        }
        if (formAppointmentCounter === 0) {
            formAppointmentCounter += 1
        } else {
            removeInsertAfter(formAppointment)
        }
        let newEl = document.createElement('div')
        if (formAppointment.value.length === 0) {
            newEl.classList.add('invalid-feedback')
            formAppointment.classList.remove('is-valid')
            formAppointment.classList.add('is-invalid')
            newEl.innerHTML = 'Bitte wähle einen Termin aus.'
            insertAfter(newEl, formAppointment)
        } else {
            newEl.classList.add('valid-feedback')
            formAppointment.classList.remove('is-invalid')
            formAppointment.classList.add('is-valid')
            //newEl.innerHTML = 'Sieht sehr gut aus!'
            //insertAfter(newEl, formAppointment)
        }
    })
}

/**
 * validate origin
 */
if (formOrigin) {
    formOrigin.addEventListener('change', () => {
        if (formOriginCounter === 0) {
            formOriginCounter += 1
        } else {
            removeInsertAfter(formOrigin)
        }
        let newEl = document.createElement('div')
        if(formOrigin.hasAttribute('required')){
            console.log('origin required!')
            if (formOrigin.value.length < 1) {
                newEl.classList.add('invalid-feedback')
                formOrigin.classList.remove('is-valid')
                formOrigin.classList.add('is-invalid')
                newEl.innerHTML = 'Woher kommst du denn?'
                insertAfter(newEl, formOrigin)
            } else {
                newEl.classList.add('valid-feedback')
                formOrigin.classList.remove('is-invalid')
                formOrigin.classList.add('is-valid')
                newEl.innerHTML = 'Cool!'
                insertAfter(newEl, formOrigin)
            }
        } else {
            if (formOrigin.value.length < 1) {
                newEl.classList.add('invalid-feedback','is-optional')
                formOrigin.classList.remove('is-valid')
                formOrigin.classList.add('is-optional')
                newEl.innerHTML = 'Woher kommst du denn?'
                insertAfter(newEl, formOrigin)
            } else {
                newEl.classList.add('valid-feedback')
                formOrigin.classList.remove('is-optional')
                formOrigin.classList.add('is-valid')
                newEl.innerHTML = 'Cool!'
                insertAfter(newEl, formOrigin)
            }
        }
    })
}

/**
 * validate Objective
 */
if (formObjective) {
    formObjective.addEventListener('change', () => {
        if(formObjective.hasAttribute('required')){
            console.log('objective required!')
        }
        if (formObjectiveCounter === 0) {
            formObjectiveCounter += 1
        } else {
            removeInsertAfter(formObjective)
        }
        let newEl = document.createElement('div')
        if (formObjective.value.length === 0) {
            newEl.classList.add('invalid-feedback')
            formObjective.classList.remove('is-valid')
            formObjective.classList.add('is-invalid')
            newEl.innerHTML = 'Bitte gibt dein bvorzugtes Zustellgebiet an.'
            insertAfter(newEl, formObjective)
        } else {
            newEl.classList.add('valid-feedback')
            formObjective.classList.remove('is-invalid')
            formObjective.classList.add('is-valid')
            //newEl.innerHTML = 'Nice!'
            //insertAfter(newEl, formObjective)
        }
    })
}

/**
 * validate Activity
 */
if (formActivity) {
    formActivity.addEventListener('change', () => {
        if(formActivity.hasAttribute('required')){
            console.log('activity required!')
        }
        if (formActivityCounter === 0) {
            formActivityCounter += 1
        } else {
            removeInsertAfter(formActivity)
        }
        let newEl = document.createElement('div')
        if (formActivity.value.length === 0) {
            newEl.classList.add('invalid-feedback')
            formActivity.classList.remove('is-valid')
            formActivity.classList.add('is-invalid')
            newEl.innerHTML = 'Bitte wähle eine Tätigkeit aus.'
            insertAfter(newEl, formActivity)
        } else {
            newEl.classList.add('valid-feedback')
            formActivity.classList.remove('is-invalid')
            formActivity.classList.add('is-valid')
            //newEl.innerHTML = 'Nice!'
            //insertAfter(newEl, formObjective)
        }
    })
}

/**
 * validate Salutation
 */
if (formSalutation) {
    console.log("salutation 1")
    formSalutation.addEventListener('change', () => {
        console.log("salutation required! A")
        if(formSalutation.hasAttribute('required')){
            console.log('salutation required!')
        }
        if (formSalutationCounter === 0) {
            formSalutationCounter += 1
        } else {
            removeInsertAfter(formSalutation)
        }
        let newEl = document.createElement('div')
        console.log(" formSalutation.value.length", formSalutation.value.length)
        console.log(" formSalutation.value", formSalutation.value)
        if (formSalutation.value.length === 0 || formSalutation.value === "Auswählen") {
            newEl.classList.add('invalid-feedback')
            formSalutation.classList.remove('is-valid')
            formSalutation.classList.add('is-invalid')
            newEl.innerHTML = 'Bitte wähle eine Anrede aus.'
            insertAfter(newEl, formSalutation)
        } else {
            newEl.classList.add('valid-feedback')
            formSalutation.classList.remove('is-invalid')
            formSalutation.classList.add('is-valid')
            //newEl.innerHTML = 'Nice!'
            //insertAfter(newEl, formObjective)
        }
    })
}

/**
 * validate Car
 */
if (formCar) {
    formCar.addEventListener('change', () => {
        if(formCar.hasAttribute('required')){
            console.log('car required!')
        }
        if (formCarCounter === 0) {
            formCarCounter += 1
        } else {
            removeInsertAfter(formCar)
        }
        let newEl = document.createElement('div')
        if (formCar.value.length === 0) {
            newEl.classList.add('invalid-feedback')
            formCar.classList.remove('is-valid')
            formCar.classList.add('is-invalid')
            newEl.innerHTML = 'Bitte wähle eine Option aus.'
            insertAfter(newEl, formCar)
        } else {
            newEl.classList.add('valid-feedback')
            formCar.classList.remove('is-invalid')
            formCar.classList.add('is-valid')
            //newEl.innerHTML = 'Nice!'
            //insertAfter(newEl, formObjective)
        }
    })
}

/**
 * check form for requirements
 */
function checkFormRequirements() {
    if (formFirstName) {
        formFirstName.dispatchEvent(new Event('change'))
    }
    if (formLastName) {
        formLastName.dispatchEvent(new Event('change'))
    }
    if (formEmail) {
        formEmail.dispatchEvent(new Event('change'))
    }
    if (formWebsite) {
        formWebsite.dispatchEvent(new Event('change'))
    }
    if (formPhone) {
        formPhone.dispatchEvent(new Event('change'))
    }
    if (formSubject) {
        formSubject.dispatchEvent(new Event('change'))
    }
    if (formMessage) {
        formMessage.dispatchEvent(new Event('change'))
    }
    if (formAppointment) {
        formAppointment.dispatchEvent(new Event('change'))
    }
    if (formOrigin) {
        formOrigin.dispatchEvent(new Event('change'))
    }
    if (formCompany) {
        formCompany.dispatchEvent(new Event('change'))
    }
    if (formObjective) {
        formObjective.dispatchEvent(new Event('change'))
    }
    if (formCity) {
        formCity.dispatchEvent(new Event('change'))
    }
    if (formStreet) {
        formStreet.dispatchEvent(new Event('change'))
    }
    if (formPostalCode) {
        formPostalCode.dispatchEvent(new Event('change'))
    }
    if (formCar) {
        formCar.dispatchEvent(new Event('change'))
    }
    if (formSalutation) {
        formSalutation.dispatchEvent(new Event('change'))
    }
    if (formActivity) {
        formActivity.dispatchEvent(new Event('change'))
    }
    let failMessages = document.getElementsByClassName('is-invalid')
    let formRequiredFields = 0
    if (thisForm) {
        formRequiredFields = thisForm.querySelectorAll("[required]")
    }
    if (thisFormAppointment)  {
        formRequiredFields = thisFormAppointment.querySelectorAll("[required]")
    }
    if (failMessages.length === 0) {
        return true
    } else {
        return false
    }
}

/**
 * enable disable send button
 */
if (dataCheckBox) {
    dataCheckBox.addEventListener('click', () => {
        enableDisableSendButton()
    })
}

/**
 *  enable or disable send button
 */
function enableDisableSendButton() {
    checkFormRequirements()
    submitButton.classList.toggle('hide-button')
    fakeSubmitButton.classList.toggle('hide-button')
}

/**
 * function set cookie for message
 */
/*function createCookie(name,value,seconds) {
    let expires = ""
    if (seconds) {
        let date = new Date()
        date.setTime(date.getTime()+(seconds*1000))
        let expires = "; expires="+date.toUTCString()
    }
    document.cookie = name+"="+value+expires+"; path=/";
}*/

/**
 * on submit function
 * after that - start google recaptcha
 */
if (thisForm) {
    thisForm.addEventListener('submit', (event) => {
        console.log('on submit..')
        //check form again
        if (checkFormRequirements()) {
            //prevent form submit
            event.preventDefault();
            // execute recaptcha
            grecaptcha.execute();
        } else {
            //prevent form submit
            event.preventDefault();
        }
    })
}
if (thisFormAppointment) {
    thisFormAppointment.addEventListener('submit', (event) => {
        console.log('on submit..')
        //check form again
        if (checkFormRequirements()) {
            //prevent form submit
            event.preventDefault();
            // execute recaptcha
            grecaptcha.execute();
        } else {
            //prevent form submit
            event.preventDefault();
        }
    })
}
/**
 * on completed function - called from recaptcha
 */
function onCompleted() {
    console.log('on completed..')
    let loading = document.getElementById('loading')
    return new Promise(function(resolve, reject) {

        // check if recaptcha is undefined
        if (grecaptcha === undefined) {
            console.log("grecaptcha is undefined error")
            reject();
        }

        // check if response exists
        let response = grecaptcha.getResponse();
        if (!response) {
            console.log("could not get recaptcha response error")
            reject();
        }

        if (thisForm) {
            // switch off native html5 validation
            thisForm.noValidate = false;
            // Disable the submit button
            submitButton.setAttribute('disabled', 'disabled');
            // Change the "Submit" text
            submitButton.value = 'Please wait...';
            // submit form
            thisForm.submit();
        }

        if (thisFormAppointment) {
            // switch off native html5 validation
            thisFormAppointment.noValidate = false;
            // Disable the submit button
            submitButton.setAttribute('disabled', 'disabled');
            // Change the "Submit" text
            submitButton.value = 'Please wait...';
            // submit form
            thisFormAppointment.submit();
        }

        // set loading animation
        loading.classList.toggle('d-none')
        loading.classList.toggle('d-flex')

        // reset recaptcha
        grecaptcha.reset();

        //set cookie for feedback message
        //createCookie("action-status", "show", 60)

    }); //end promise
}

/**
 * check if cookie exists and show or hide
 * form action feedback
 */
/*function checkFormActionFeedback() {
    let actionStatus = (localStorage.getItem('action-status') === 'show')
    if (actionStatus) {
        if (formActionFeedback) {
            formActionFeedback.classList.toggle('d-none')
            formActionFeedback.classList.toggle('d-flex')
        }
    }
}*/

/**
 * functions on dom content loaded
 */
/*document.addEventListener('DOMContentLoaded', function () {
    checkFormActionFeedback()
});*/

